export default "__VITE_ASSET__DrgWigHD__"